//App
import { UserApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const userApi: UserApiType = {
  getLookups: () => apiClient.get(endPoints.user.getLookups()),
  get: (value) => apiClient.get(endPoints.user.get(value)),
  getAll: (payload) => apiClient.get(endPoints.user.getAll(), payload),
  save: (payload) => apiClient.post(endPoints.user.save(), payload),
  delete: (value) => apiClient.delete(endPoints.user.delete(value)),
  activate: (value) => apiClient.post(endPoints.user.activate(value)),
  deactivate: (value) => apiClient.post(endPoints.user.deActivate(value)),
  changePassword: (payload) =>
    apiClient.post(endPoints.user.changePassword(), payload),
  resendConfirmationEmail: (payload) =>
    apiClient.post(endPoints.user.resendConfirmationEmail(), payload),
  unlockUser: (payload) =>apiClient.post(endPoints.user.unlockUser(), payload),
  resetPassword: (payload) => apiClient.post(endPoints.user.resetPassword(), payload),
};

export default userApi;
